module.exports = require('./helpers/bundle-url').getBundleURL('gLNYM') + "logo-dark.eefe0b7f.svg";